import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import { router } from '@src/router/index';
import { isNavigationFailure } from 'vue-router';
import { useStoreUser } from '@src/store/modules/user';
import { useStoreCity } from '@src/store/modules/city';
import { useStoreLoginModal } from '@src/store/modules/loginModal';

router.beforeEach(async (to, from, next) => {
    NProgress.start();

    const storeUser = useStoreUser();
    const storeCity = useStoreCity();
    const storeLoginModal = useStoreLoginModal();

    // 基于 URL 参数的 token 登录
    if (to.query.token) {
        storeUser.auth.token = to.query.token as string;
    }

    // 全量城市字典免鉴权且全局通用，所有路由统一预拉；消费方均为响应式，无需阻塞导航
    storeCity.fetchCityList();

    // 补拉用户与城市数据，内部各请求均带去重，重复导航不会重复发起
    const loadAuthData = async () => {
        if (!Object.keys(storeUser.user).length) await storeUser.getUser();
        if (storeUser.user.userId) await storeCity.initializeCityData(storeUser.user.userId);
    };

    // 未登录不发任何鉴权请求；已登录则不分路由一律补齐，白名单页的账户菜单等同样依赖
    const loadingAuthData = storeUser.auth.token ? loadAuthData() : null;

    // 白名单路由无需鉴权，数据异步补齐即可，不阻塞首屏；失败交由请求层统一处理（401 清态并刷新）
    if (to.meta.whiteList) {
        loadingAuthData?.catch(() => {});
        return next();
    }

    // 非白名单默认需鉴权：无 token 则弹登录框
    if (!storeUser.auth.token) {
        storeLoginModal.open({ redirect: to.fullPath });
        // 已有来源页时中止本次导航，保留当前页并展示弹窗
        if (from.name) return next(false);
        // 直接访问受保护路由时，先落到首页再展示弹窗
        return next({ name: 'Index', replace: true });
    }

    // 受保护路由需等用户与城市数据就绪后再进入
    await loadingAuthData;

    next();
});

router.afterEach((_to, _from, failure) => {
    NProgress.done();
    if (isNavigationFailure(failure)) {
        console.error('路由错误啦', failure);
    }
});
